module.exports = __webpack_public_path__ + "static/media/text-image.2ee3d6d2.avif";